// Copyright (c) 2017 Deere & Company

import Criteria, {getDefaultState as getDefaultCriteriaState} from '../state/criteria';
import actions from '../../actions-list';
import {updateList} from '../../../shared/services/list-selections';

const updateTerritory = (state, action) =>

    Criteria.update(state, {
        territories: {
            $set: updateList(
                action.territory,
                action.isSelected,
                'territory',
                state.territories
            )
        }
    });

const selectAllTerritories = (state, action) => {

    const toggleSelectedTerritories = state.territories.length ?
        [] :
        action.territories;

    return Criteria.update(state, {
        territories: {
            $set: toggleSelectedTerritories
        }
    });

};

const selectCriteria = (state, action) =>
    Criteria.update(state, {
        [action.attribute]: {
            $set: action.value
        }
    });

const resetCriteria = () => getDefaultCriteriaState();

export default (state = getDefaultCriteriaState(), action) => {

    const actionTypes = {
        [actions.RESET_AUDIT_SUMMARY_REPORT_CRITERIA]: resetCriteria,
        [actions.SELECT_AUDIT_SUMMARY_REPORT_CRITERIA]: selectCriteria,
        [actions.SELECT_AUDIT_SUMMARY_REPORT_TERRITORY]: updateTerritory,
        [actions.SELECT_ALL_AUDIT_SUMMARY_REPORT_TERRITORIES]: selectAllTerritories
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/audit-summary/reducers/criteria.js